import fetch from "isomorphic-fetch";

import { withNetworkAuthHeaders, withURLParam } from "./apiHelpers";
import { apiConf } from "./index";

export function searchOrganisation(params: { q: string }) {
    return fetch(
        withNetworkAuthHeaders(
            withURLParam(`${apiConf.BACK_URL}/organisations/children/search`, { q: params.q }),
        ),
    );
}
